import { ActionTypes } from './types'

export const postVizionEmbedUrl = (): VizionEmbedUrlAction => ({
  type: ActionTypes.REQUEST_VIZION_EMBED_URL,
})

export const successVizionEmbedUrl = (
  embedurl: string,
): VizionEmbedUrlAction => ({
  type: ActionTypes.SUCCESS_VIZION_EMBED_URL,
  payload: { embedurl },
})

export const errorVizionEmbedUrl = (error: string): VizionEmbedUrlAction => ({
  type: ActionTypes.ERROR_VIZION_EMBED_URL,
  payload: { error },
})

export type VizionEmbedUrlAction =
  | { type: ActionTypes.REQUEST_VIZION_EMBED_URL }
  | {
      type: ActionTypes.SUCCESS_VIZION_EMBED_URL
      payload: { embedurl: string }
    }
  | { type: ActionTypes.ERROR_VIZION_EMBED_URL; payload: { error: string } }
